import * as React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { inputs, checkboxes } from "./FieldForm";
import {
  Typography,
  Box,
  TextField,
  Grid,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useMemo } from "react";
import axiosInstance from "../../../../common/helpers/axios.instance"; 
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { useState } from "react";


export default function EditFieldModal({ isOpen, handleClose, id, editField }) {
  const [fields, setFields] = React.useState({});
  const complexId = useSelector((state) => state.user.user.complexId);
  const [complexData, setComplexData] = useState({});

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("fields", fields);
    editField(id, fields);
  };

  const fetchFieldData = async (id) => {
    try {
      const field = await axiosInstance.get(
        process.env.REACT_APP_BASE_API + `/locations/${id}`
      );
      field.data.data.length = +(field.data.data.length ?? 0);
      field.data.data.width = +(field.data.data.width ?? 0);

      setFields(field.data.data);
    } catch (err) {
      console.log(err);
      alert("Ndodhi nje problem");
    }
  };

  useEffect(() => {
    if (isOpen) fetchFieldData(id);
  }, [isOpen]);

  let selectedFieldType = checkboxes.find((checkbox) => fields[checkbox.name]);
 
  useEffect(() => {
    const fetchComplexData = async () => {
      try {
        const result = await axiosInstance.get(process.env.REACT_APP_BASE_API + `/complexes/${complexId}`);
        setComplexData({
          opensAt: result.data.data.complex?.[0]?.workingHours.from == 0 ? 24 : result.data.data.complex?.[0]?.workingHours.from,
          closesAt: result.data.data.complex?.[0]?.workingHours.to == 0 ? 24 : result.data.data.complex?.[0]?.workingHours.to,
        });

      } catch (error) {
        console.log("Error fetching complex data:", error);
      }
    };

    if (complexId && isOpen) {
      fetchComplexData();
    }
  }, [complexId, isOpen]);

  const availableHours = useMemo(() => {
    const minHour = complexData?.opensAt || 1;
    const maxHour = complexData?.closesAt || 24;
    
    const hours = [];
    for (let hour = minHour; hour <= maxHour; hour++) {
      hours.push({
        value: `${String(hour).padStart(2, "0")}:00`,
        label: `${String(hour).padStart(2, "0")}:00`,
      });
    }
    
    return hours;
  }, [complexData]);

  const getAvailableStartHours = (index) => {
    const priceRanges = fields?.priceRanges || [];
    if (index === 0) return availableHours;

    const previousRange = priceRanges[index - 1];
    if (!previousRange || !previousRange.endTime) return availableHours;

    const previousEndHour = parseInt(previousRange.endTime.split(":")[0]);
    return availableHours.filter((hour) => {
      const hourValue = parseInt(hour.value.split(":")[0]);
      return hourValue >= previousEndHour;
    });
  };

  const getAvailableEndHours = (startTime) => {
    if (!startTime) return availableHours;
    const startHour = parseInt(startTime.split(":")[0]);
    return availableHours.filter((hour) => {
      const hourValue = parseInt(hour.value.split(":")[0]);
      return hourValue > startHour;
    });
  };
 
  const handlePriceRangeAdd = () => {
    const currentRanges = fields.priceRanges || [];
    const lastRange = currentRanges[currentRanges.length - 1];

    const newRange = {
      startTime: lastRange?.endTime || "",
      endTime: "",
      price: "",
    };

    setFields((prev) => ({
      ...prev,
      priceRanges: [...currentRanges, newRange],
    }));
  };

  const handlePriceRangeRemove = (index) => {
    setFields((prev) => ({
      ...prev,
      priceRanges: prev.priceRanges.filter((_, i) => i !== index),
    }));
  };

  const handlePriceRangeChange = (index, field, value) => {
    setFields((prev) => {
      const newPriceRanges = [...(prev.priceRanges || [])];
      newPriceRanges[index] = {
        ...newPriceRanges[index],
        [field]: value,
      };
      return {
        ...prev,
        priceRanges: newPriceRanges,
      };
    });
  };

  return (
    <Dialog onClose={handleClose} open={isOpen} fullWidth>
      <DialogTitle>Modifiko fushen e zgjedhur</DialogTitle>
      <Box m={2}>
        <form onSubmit={handleSubmit}>
          <Grid container rowGap={2}>
            {inputs.map((input) => (
              <Grid item xs={12} key={input.name}>
                <TextField
                  type={input.type}
                  label={input.label}
                  name={input.name}
                  inputProps={{ min: input.min ?? 0 }}
                  fullWidth
                  value={fields[input.name] ?? ""}
                  onChange={(e) =>
                    setFields((f) => ({
                      ...f,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </Grid>
            ))}

            <Grid item xs={12}>
              <RadioGroup
                row
                value={selectedFieldType?.name || ""}
                onChange={(e) => {
                  const clearedFields = { ...fields };
                  checkboxes.forEach((checkbox) => {
                    clearedFields[checkbox.name] = false;
                  });

                  setFields({
                    ...clearedFields,
                    [e.target.value]: true,
                  });
                }}
              >
                {checkboxes.map((checkbox) => (
                  <FormControlLabel
                    key={checkbox.name}
                    value={checkbox.name}
                    control={<Radio />}
                    label={checkbox.label}
                  />
                ))}
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Çmimet sipas kohës
              </Typography>

              {fields?.priceRanges?.map((range, index) => (
                <Box
                  key={index}
                  sx={{
                    mb: 2,
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    position: "relative",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel>Nga ora</InputLabel>
                        <Select
                          value={range.startTime || ""}
                          onChange={(e) =>
                            handlePriceRangeChange(
                              index,
                              "startTime",
                              e.target.value
                            )
                          }
                          label="Nga ora"
                          disabled={
                            index > 0 && !fields.priceRanges[index - 1]?.endTime
                          }
                        >
                          {getAvailableStartHours(index).map((hour) => (
                            <MenuItem key={hour.value} value={hour.value}>
                              {hour.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel>Deri ora</InputLabel>
                        <Select
                          value={range.endTime || ""}
                          onChange={(e) =>
                            handlePriceRangeChange(
                              index,
                              "endTime",
                              e.target.value
                            )
                          }
                          label="Deri ora"
                          disabled={!range.startTime}
                        >
                          {getAvailableEndHours(range.startTime).map((hour) => (
                            <MenuItem key={hour.value} value={hour.value}>
                              {hour.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Çmimi"
                        type="number"
                        fullWidth
                        value={range.price || ""}
                        onChange={(e) =>
                          handlePriceRangeChange(index, "price", e.target.value)
                        }
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                  </Grid>

                  <IconButton
                    size="small"
                    onClick={() => handlePriceRangeRemove(index)}
                    sx={{ position: "relative", right: -10, top: -10 }}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ))}

              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={handlePriceRangeAdd}
                sx={{ mt: 1 }}
              >
                Shto segment kohor
              </Button>
            </Grid>
          </Grid>
        </form>{" "}
      </Box>
      <DialogActions>
        <Button color="error" variant="contained" onClick={handleClose}>
          Mbyll
        </Button>
        <Button variant="contained" type="submit" onClick={handleSubmit}>
          <span style={{ color: "white" }}>Ruaj</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
